import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "./utils/rtlPlugin";
import { SettingsProvider, useSettings } from "./contexts/SettingsContext";

const rtlCache = createCache({
  key: "mui-rtl",
  stylisPlugins: [rtlPlugin],
  prepend: true,
});

const ltrCache = createCache({
  key: "mui",
  prepend: true,
});

const AppWithDirection = () => {
  const {
    settings: { language },
  } = useSettings();

  const cache = language === "ar" ? rtlCache : ltrCache;

  return (
    <CacheProvider value={cache}>
      <App />
    </CacheProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <SettingsProvider>
      <AppWithDirection />
    </SettingsProvider>
  </BrowserRouter>
);
